<div class="flex flex-col gap-4">
  <p-card class="custom-card" header="Dane dokumentu">
    <div class="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-3 gap-4 p-4">
      <app-preview-data-wrapper
        [data]="document().typDokumentu?.nazwa"
        label="Nazwa dokumentu"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-3 gap-4 p-4">
      <app-preview-data-wrapper
        [dataType]="PreviewDataType.DATE_TIME"
        [data]="document().dataWplywu"
        label="Czas wysłania"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
      <app-preview-data-wrapper
        [dataType]="PreviewDataType.DATE_TIME"
        [data]="document().dataPierwszegoZawiadomienia"
        label="Czas pierwszego zawiadomienia"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
      <app-preview-data-wrapper
        [dataType]="PreviewDataType.DATE_TIME"
        [data]="document().dataDrugiegoZawiadomienia"
        label="Czas drugiego zawiadomienia"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
  </p-card>

  @if (document() | isZUSDokument) {
    <span>{{ document() }}</span>
    <p-card>
      <strong>Informacja</strong><br />
      Po wysłaniu wniosku do ZUS, system nie przechowuje danych o treści i
      załącznikach.<br />
      Wniosek wraz z załącznikami będzie dostępny na eZUS.
    </p-card>
  } @else {
    <p-card class="custom-card" header="Poświadczenie doręczenia">
      @if (document().poswiadczenie != null) {
        Dnia
        {{ document().poswiadczenie?.dataUtworzenia | date: 'yyyy-MM-dd' }} o
        godzinie
        {{ document().poswiadczenie?.dataUtworzenia | date: 'HH:mm' }} z
        jednostki {{ document().poswiadczenie?.adresat }} otrzymano Urzędowe
        Poświadczenie Odbioru.
        <div class="flex gap-4 mt-4">
          <p-button
            styleClass="customInfoButton outlined btn-custom-bolded"
            size="small"
            label="Wyświetl poświadczenie"
            (click)="showPoswiadczenieVisualization()"
          />
          <p-button
            styleClass="customInfoButton outlined btn-custom-bolded"
            size="small"
            label="Eksportuj poświadczenie"
            (click)="exportPoswiadczenie()"
          />
        </div>
      } @else {
        Jednostka adresata wniosku nie przesłała jeszcze Urzędowego
        Poświadczenia Odbioru;
      }
    </p-card>

    <p-card class="custom-card" header="Załączniki">
      @if (document() | shouldShowNoAttachments) {
        <div class="p-4 text-center text-gray-500 italic">Brak załączników</div>
      } @else {
        <div class="wide">
          <p-table
            [value]="document().zalaczniki || []"
            [paginator]="false"
            [tableStyle]="{ 'min-width': '50rem' }"
            styleClass="customPrimeTable"
          >
            <ng-template #header>
              <tr>
                <th style="width: 25%">Nazwa</th>
                <th style="width: 25%">Rozmiar</th>
                <th style="width: 25%">Akcje</th>
              </tr>
            </ng-template>
            <ng-template #body let-attachment>
              <tr>
                <td>{{ attachment.nazwa }}</td>
                <td>{{ attachment.rozmiar }}</td>
                <td>
                  <div class="flex gap-4">
                    <p-button
                      type="button"
                      (click)="downloadAttachment(attachment)"
                      ariaLabel="Pobierz"
                      pTooltip="Pobierz"
                      tooltipPosition="top"
                      [rounded]="true"
                      [text]="true"
                    >
                      <i class="pi pi-download icon" aria-hidden="true"></i>
                    </p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      <div class="narrow">
        <div class="flex flex-col gap-10">
          @for (
            attachment of document().zalaczniki || [];
            track attachment.id
          ) {
            <p-card>
              <div class="flex flex-col">
                <app-preview-data-wrapper
                  label="Nazwa"
                  [data]="attachment.nazwa"
                ></app-preview-data-wrapper>
                <hr class="limiter" />
                <app-preview-data-wrapper
                  label="Rozmiar"
                  [data]="attachment.rozmiar"
                ></app-preview-data-wrapper>
                <div class="flex justify-end gap-5 mt-5">
                  <p-button
                    label="Edytuj"
                    styleClass="customInfoButton outlined"
                    (click)="downloadAttachment(attachment)"
                  />
                </div>
              </div>
            </p-card>
          }
        </div>
      </div>
    </p-card>
    <div class="flex mt-4 gap-2 flex-wrap">
      @if (inboxType() !== InboxType.ARCHIVED) {
        <p-button
          styleClass="customInfoButton outlined btn-custom-bolded"
          size="small"
          label="Archiwizuj"
          (click)="archiveDocumentDialog()"
        />
      } @else {
        <p-button
          styleClass="customInfoButton outlined btn-custom-bolded"
          size="small"
          label="Przywróć z archiwum"
          (click)="restoreFromArchiveDocumentDialog()"
        />
      }
      <p-button
        styleClass="customInfoButton outlined btn-custom-bolded"
        size="small"
        (click)="showApplicationVisualization()"
        label="Podgląd wniosku"
      />
      <p-button
        styleClass="customInfoButton outlined btn-custom-bolded"
        size="small"
        label="Eksportuj"
        (click)="exportApplication()"
      />
      @if (document() | shouldShowCorrespondenceIcon: inboxType()) {
        <p-button
          styleClass="customInfoButton outlined btn-custom-bolded"
          size="small"
          label="Koresponduj w sprawie"
          (click)="correspond(document())"
        />
      }
      <p-button
        styleClass="customInfoButton outlined btn-custom-bolded"
        size="small"
        label="Podpis dokumentu"
        (click)="showDocumentSignature()"
      />
    </div>
  }
</div>
